/**
 * Router `location.state` key carrying which dispense row the Till page should
 * pre-select. A Till belongs to a patient and holds one row per dispense, so
 * without this the page falls back to the patient's oldest dispense instead of
 * the one the user just saved.
 */
export const TILL_FOCUS_DISPENSE_STATE_KEY = "focusDispenseId";

/** Build the nav state for `navigate('/till/:tillId', ...)` after saving a dispense. */
export function buildTillFocusState(
  dispenseId: number | string | null | undefined,
): Record<string, unknown> | undefined {
  const id = toDispenseId(dispenseId);
  return id == null ? undefined : { [TILL_FOCUS_DISPENSE_STATE_KEY]: id };
}

/** Read the focused dispense id back out of `location.state` (null when absent). */
export function readTillFocusDispenseId(state: unknown): number | null {
  if (!state || typeof state !== "object") return null;
  return toDispenseId(
    (state as Record<string, unknown>)[TILL_FOCUS_DISPENSE_STATE_KEY],
  );
}

function toDispenseId(value: unknown): number | null {
  if (value === null || value === undefined || value === "") return null;
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
}
